<template>
  <footer class="site-footer-back">
    <div v-if="
          $currentUserRoles.includes('manager') ||
            $currentUserRoles.includes('managerAssist')"
    >
      <HistoryNotifications
        class="flowHistoryButton shadow-sm"
      />
    </div>
    <!--    <div class="text-right">-->
    <!--      Powered by <strong>ObiVan</strong>-->
    <!--      <a href="http://bytefury.com/" target="_blank">-->
    <!--        Bytefury-->
    <!--      </a>-->
    <!--    </div>-->
  </footer>
</template>

<script>

import HistoryNotifications from "@/components/notifications/HistoryNotifications"

export default {
  components: {
    HistoryNotifications
  }
}

</script>

<style scoped>
.flowHistoryButton {
  position: fixed;
  right: 0;
  bottom: 50px;
}
</style>
